module.exports = __webpack_public_path__ + "img/2.cc986e78.png";